// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// State
import { NgxsModule } from '@ngxs/store';
import { IntelligenceState } from './state/intelligence.state';
import { InboxState } from './inbox/state/inbox.state';
import { ImportState } from './import-order/state/import.state';
// Module
import { IntelligenceRoutingModule } from './intelligence-routing.module';
import { CvComponentLibraryModule } from '@cv-invision/cv.component-library.ux';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';
import {QualityModule} from './quality/quality.module';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { MetricsDashboardModule } from './metrics-dasboard/metrics-dashboard.module';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChipModule } from 'primeng/chip';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// Service
import { ComponentFactoryResolverService, HttpCoreModule } from '@cv-invision/core';
import { OrderActivityService } from './inbox/service/order-activity.service';
import { DialogService } from 'primeng/dynamicdialog';
// Components
import { InboxComponent } from './inbox/inbox.component';
import { CreateOrderComponent } from './create-order/create-order.component';
import { ImportOrderComponent } from './import-order/import-order.component';
import { CustomActionCellComponent } from './inbox/custom-action-cell/custom-action-cell.component';
import { CustomIDCellComponent } from './inbox/custom-id-cell/custom-id-cell.component';
import { OrderContentDetailComponent } from './inbox/order-content-detail/order-content-detail.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ReSubmitOrderComponent } from './inbox/resubmit-order/resubmit-order.component';
import { InboxHeaderComponent } from './inbox/header/inbox-header.component';
import { CustomStatusCellComponent } from './inbox/custom-status-cell/custom-status-cell.component';
import { CustomStatusImportCellComponent } from './import-order/custom-status-cell/custom-status-cell.component';
import { ConfirmationImportModalComponent } from './import-order/confirmation-import-modal/confirmation-import-modal.component';
import { CustomFlagsCellComponent } from './inbox/custom-flags-cell/custom-flags-cell.component';
import { CustomSmartqcCellComponent } from './inbox/custom-smartqc-cell/custom-smartqc-cell.component';
import { CustomTooltipFlagCellComponent } from './inbox/custom-tooltip-cell/custom-tooltip-cell.component';
import { IntelligenceComponent } from "./intelligence.component";
import { OrderActivitDialogComponent } from './inbox/dialogs/order-activity/order-activity-dialog.component';
import { CreateOrderFormComponent } from './create-order/components/create-order-form/create-order-form.component';
import { CreateOrderProgressTrackerTableComponent } from './create-order/components/create-order-progress-tracker-table/create-order-progress-tracker-table.component';
import { EngagementFileUploadComponent } from './shared/engagement-file-upload/engagement-file-upload.component';
import { TrackingClientDropdownComponent } from './inbox/tracking-client-dropdown/tracking-client-dropdown.component';
import { ReOpenDialogComponent } from './inbox/dialogs/reopen-action/reopen-dialog.component';
import { CUScoreOverwriteDialogComponent } from './inbox/dialogs/cu-score-overwrite/cu-score-overwrite-dialog.component';
import { ManageQueuesModule } from './manage-queues/manage-queues.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IntelligenceRoutingModule,
		CvComponentLibraryModule,
		NgxsModule.forFeature([IntelligenceState, InboxState, ImportState]),
		QualityModule,
		ReactiveFormsModule,
		// Third modules
		NgbDatepickerModule,
		AgGridModule.withComponents([]),
		HttpCoreModule,
		ButtonModule,
		TableModule,
		DropdownModule,
		MetricsDashboardModule,
		ManageQueuesModule,
		OverlayPanelModule,
		MultiSelectModule,
		ChipModule,
		CheckboxModule,
		TooltipModule,
		InputTextModule,
		InputNumberModule,
		ToastModule,
        ConfirmDialogModule,
	],
	declarations: [
		InboxComponent,
		InboxHeaderComponent,
		CreateOrderComponent,
		ImportOrderComponent,
		OrderContentDetailComponent,
		DashboardComponent,
		CreateOrderFormComponent,
		CreateOrderProgressTrackerTableComponent,
		TrackingClientDropdownComponent,
		// Grid Custom Cells
		CustomActionCellComponent,
		CustomIDCellComponent,
		ReSubmitOrderComponent,
		CustomStatusCellComponent,
		CustomStatusImportCellComponent,
		ConfirmationImportModalComponent,
		CustomFlagsCellComponent,
		CustomTooltipFlagCellComponent,
		CustomSmartqcCellComponent,
		IntelligenceComponent,
		OrderActivitDialogComponent,
		ReOpenDialogComponent,
		CUScoreOverwriteDialogComponent,
		EngagementFileUploadComponent
	],
	entryComponents: [
		InboxHeaderComponent,
		// Grid Custom Cells
		CustomTooltipFlagCellComponent,
		CustomFlagsCellComponent,
		CustomActionCellComponent,
		CustomSmartqcCellComponent,
		CustomIDCellComponent,
		CustomStatusCellComponent,
		CustomStatusImportCellComponent,
		OrderContentDetailComponent,
		ReSubmitOrderComponent,
		ConfirmationImportModalComponent
	],
	providers: [
		ComponentFactoryResolverService,
		OrderActivityService,
		DialogService
	]
})
export class IntelligenceModule {}
